import React, { useEffect, useState } from "react";
import { Play } from "lucide-react";
import { api } from "@/lib/api";

export const YouTubeFeed = ({ compact = false, exclude = null }) => {
  const [videos, setVideos] = useState([]);
  const [active, setActive] = useState(null);

  useEffect(() => { api.get("/youtube/videos?limit=15").then(({ data }) => setVideos(data.videos.filter((v) => !v.short && v.id !== exclude).slice(0, 3))).catch(() => {}); }, [exclude]);

  if (!videos.length) return null;

  if (compact) return (
    <div data-testid="youtube-feed" className="flex flex-col gap-3 flex-1">
      <p className="text-xs tracking-[0.3em] text-cometa-dorado font-semibold">ÚLTIMOS VIDEOS</p>
      {videos.map((v) => (
        <a key={v.id} href={v.url} target="_blank" rel="noreferrer" data-testid={`youtube-video-${v.id}`} className="group flex items-center gap-4 bg-cometa-crema/5 border border-cometa-crema/10 rounded-2xl p-2.5 hover:bg-cometa-crema/10 hover:-translate-y-0.5 transition">
          <span className="relative w-28 md:w-32 shrink-0 aspect-video rounded-xl overflow-hidden">
            <img loading="lazy" decoding="async" src={v.thumbnail} alt={v.title} className="w-full h-full object-cover group-hover:scale-110 transition duration-500" />
            <span className="absolute inset-0 flex items-center justify-center"><span className="h-8 w-8 rounded-full bg-cometa-carmesi text-white flex items-center justify-center"><Play size={14} fill="currentColor" /></span></span>
          </span>
          <span className="text-base md:text-lg font-display leading-snug line-clamp-2 group-hover:text-cometa-dorado transition">{v.title}</span>
        </a>
      ))}
    </div>
  );

  return (
    <div data-testid="youtube-feed">
      <p className="text-sm tracking-[0.3em] text-cometa-dorado mb-6">ÚLTIMOS VIDEOS</p>
      <div className="grid md:grid-cols-3 gap-6">
        {videos.map((v) => (
          <article key={v.id} className="group bg-cometa-crema/5 border border-cometa-crema/10 rounded-[1.75rem] p-3 hover:bg-cometa-crema/10 hover:-translate-y-1 transition duration-300" data-testid={`youtube-video-${v.id}`}>
            <div className="relative aspect-video rounded-2xl overflow-hidden shadow-xl bg-cometa-tinta">
              {active === v.id ? (
                <iframe className="w-full h-full" src={`https://www.youtube.com/embed/${v.id}?autoplay=1`} title={v.title} allow="autoplay; encrypted-media; picture-in-picture" allowFullScreen />
              ) : (
                <button onClick={() => setActive(v.id)} className="w-full h-full relative text-left" aria-label={`Reproducir ${v.title}`} data-testid={`youtube-play-${v.id}`}>
                  <img loading="lazy" decoding="async" src={v.thumbnail} alt={v.title} className="w-full h-full object-cover group-hover:scale-105 transition duration-700" />
                  <span className="absolute inset-0 flex items-center justify-center"><span className="flex h-14 w-14 items-center justify-center rounded-full bg-cometa-carmesi text-white shadow-xl group-hover:scale-110 group-hover:bg-cometa-dorado group-hover:text-cometa-tinta transition"><Play size={22} fill="currentColor" /></span></span>
                </button>
              )}
            </div>
            <h3 className="mt-3 px-2 pb-1 text-lg leading-snug font-display line-clamp-2 group-hover:text-cometa-dorado transition">{v.title}</h3>
          </article>
        ))}
      </div>
    </div>
  );
};
